import { type FC, useEffect } from 'react';
import confettiJson from '@assets/lottie/confetti.json';
import { type LottieOptions, useLottie } from 'lottie-react';

interface ConfetteProps extends Omit<LottieOptions<'svg'>, 'animationData'> {
  className?: string;
  speed?: number;
}

const Confetti: FC<ConfetteProps> = ({ className, speed, ...props }) => {
  const { View, setSpeed } = useLottie({
    ...props,
    animationData: confettiJson,
  });

  useEffect(() => {
    if (speed) {
      setSpeed(speed);
    }
  }, [speed]);

  return <div className={className}>{View}</div>;
};

export { Confetti };
